'use strict';

var parseURL = require('./parseUrl');

var jsonpExtraStamp = 0;

module.exports = function (url, options, listener) {
    var trans = {},
        isCanceled = false,
        callbackName = '',
        overwritten,
        hasSetCallbackName = false,
        head = document.getElementsByTagName('head')[0],
        scriptElem = document.createElement('script'),
        backingOut = function backingOut() {
        if (hasSetCallbackName) {
            window[callbackName] = overwritten;
        } else {
            delete window[callbackName];
        }
        head.removeChild(scriptElem);
    },
        extend = options.extend,
        timer;

    scriptElem.src = url;

    var URL = parseURL(scriptElem.src);
    URL.query = extend(URL.query, options.data);

    if (options.jsonpCallback) {
        hasSetCallbackName = true;
        overwritten = window[options.jsonpCallback];
    } else {
        options.jsonpCallback = 'HySDK_' + +new Date() + jsonpExtraStamp++;
    }
    callbackName = options.jsonpCallback;
    URL.query[options.jsonp || 'callback'] = callbackName;

    trans.abort = function () {
        isCanceled = true;
        listener(null, {
            error: true,
            type: 'Abort'
        });
        backingOut();
    };

    window[callbackName] = function (data) {
        if (timer) {
            clearTimeout(timer);
        }
        if (isCanceled) {
            return;
        }
        listener(data);
        backingOut();
    };

    timer = setTimeout(function () {
        listener(null, {
            error: true,
            type: 'Timeout'
        });
        backingOut();
    }, options.timeout || 30000);

    scriptElem.async = true;
    scriptElem.charset = options.charset || 'UTF-8';
    scriptElem.src = URL.toUrl();

    scriptElem.onerror = function () {
        if (timer) {
            clearTimeout(timer);
        }
        listener(null, {
            error: true,
            type: 'Fail'
        });
        backingOut();
    };

    head.appendChild(scriptElem);

    return trans;
};


//////////////////
// WEBPACK FOOTER
// ../plugins/qunar/util/jsonp.js
// module id = 36
// module chunks = 1 3 4